/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestmentWorkflowCompletionStep {
    PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
    INVESTMENT_VEHICLE_INFORMATION = 'INVESTMENT_VEHICLE_INFORMATION',
    BANK_ACCOUNT = 'BANK_ACCOUNT',
    OTHER = 'OTHER',
    KYC_INSTRUCTIONS = 'KYC_INSTRUCTIONS',
    KYC_PERSONAL = 'KYC_PERSONAL',
    KYC_COMPANY = 'KYC_COMPANY',
    KYC_FORMS = 'KYC_FORMS',
    DECLARATIONS = 'DECLARATIONS',
    CONTRACTS = 'CONTRACTS',
    COMPLETED = 'COMPLETED',
}
